import {
  call, all, spawn
} from 'redux-saga/effects';
import oidcSagas from './oidcSaga';
import appSagas from './appSaga';
import { startEntitiesSagas } from './entitiesSaga';
import { startIntentsSagas } from './intentsSaga';
import { startFlowsSagas } from './flowsSaga';
import { startTranscriptionsSagas } from './transcriptionsSaga';
import { startStatisticsSagas } from './statisticsSaga';
import { startBotsSagas } from './botsSaga';
import { startAttachPaymentSagas } from './customerSaga';
import { startMonitoringGraphsSagas } from './monitoringGraphsSaga';
import { startAnalyticsSagas } from './analyticsSaga';

export function* startSaga() {
  yield spawn(oidcSagas);
  yield spawn(appSagas);
  yield all([
    call(startEntitiesSagas),
    call(startIntentsSagas),
    call(startFlowsSagas),
    call(startTranscriptionsSagas),
    call(startStatisticsSagas),
    call(startBotsSagas),
    call(startAttachPaymentSagas),
    call(startMonitoringGraphsSagas),
    call(startAnalyticsSagas),
  ]);
}
